<template>
  <div class="login-page">
    <div
      class="card shadow reset-password-container"
      style="border-radius: 0.75rem"
    >
      <div class="card-body login-card-body" style="border-radius: 0.75rem">
        <div class="mb-4">
          <h3 class="font-weight-bold text-dark">Reset Password</h3>

          <p v-if="errorMessage">
            <small class="text-danger">
              {{ errorMessage }}
            </small>
          </p>
          <p v-if="successMessage">
            <small class="text-success"
              >{{ successMessage }}
              <router-link :to="{ name: 'Login' }"> Login Now</router-link>
            </small>
          </p>
        </div>
        <form action="" method="post" @submit.prevent="resetPassword()">
          <div class="mb-3">
            <div class="input-group">
              <input
                :type="show.new_password ? 'text' : 'password'"
                class="form-control"
                :class="{ 'border-danger': $v.new_password.$error }"
                placeholder="Password"
                v-model="new_password"
              />
              <div class="input-group-append">
                <div
                  class="input-group-text"
                  :class="{ 'border-danger': $v.new_password.$error }"
                  @click="showPassword()"
                >
                  <span
                    class="fas"
                    :class="{
                      'fa-eye': !show.new_password,
                      'fa-eye-slash': show.new_password,
                    }"
                  ></span>
                </div>
              </div>
            </div>
            <div class="text-danger" v-if="$v.new_password.$error">
                <small v-if="!$v.new_password.required">Password is Required</small>
                <small v-if="!$v.new_password.minLength">Password must have at {{$v.new_password.$params.minLength.min}} Least</small>
              </div>
          </div>
          <div class="mb-3">
            <div class="input-group">
              <input
                :type="show.confirm_password ? 'text' : 'password'"
                class="form-control"
                :class="{
                  'border-danger':
                    $v.confirm_password.$error ||
                    !$v.confirm_password.sameAsPassword,
                }"
                placeholder="Password Confirmation"
                v-model="confirm_password"
              />
              <div class="input-group-append">
                <div
                  class="input-group-text"
                  :class="{
                    'border-danger':
                      $v.confirm_password.$error ||
                      !$v.confirm_password.sameAsPassword,
                  }"
                  @click="showConfirmPassword()"
                >
                  <span
                    class="fas"
                    :class="{
                      'fa-eye': !show.confirm_password,
                      'fa-eye-slash': show.confirm_password,
                    }"
                  ></span>
                </div>
              </div>
            </div>
            <div class="text-danger" v-if="$v.confirm_password.$error">
                <small v-if="!$v.confirm_password.required">Confirm Password is Required</small>
                <small v-if="!$v.confirm_password.minLength">Confirm Password must have at {{$v.confirm_password.$params.minLength.min}} Least</small>
                <div class="text-danger" v-if="!$v.confirm_password.sameAsPassword">
                  <small>Password must be Identical</small>
                </div>
            </div>
          </div>

          <div>
            <button
              type="submit"
              class="btn btn-danger btn-block rounded-pill"
              :disabled="submitStatus === 'PENDING'"
            >
              Reset Password
            </button>
            <hr class="my-2" />
            <router-link
              :to="{ name: 'Login' }"
              type="submit"
              class="btn btn-outline-danger btn-block mb-2 rounded-pill"
            >
              Cancel
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "../../services/ApiServices";
import { required,minLength, sameAs } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      new_password: "",
      confirm_password: "",
      reset_token: this.$route.query.token,
      successMessage: null,
      submitStatus: null,
      show: {
        new_password: false,
        confirm_password: false,
      },
    };
  },
  created() {
    document.title = "Reset Password - Manager Cabang";
  },
  validations: {
    new_password: {
      required,
      minLength: minLength(8)
    },
    confirm_password: {
      required,
      minLength: minLength(8),
      sameAsPassword: sameAs("new_password"),
    },
  },
  methods: {
    showPassword() {
      this.show.new_password = !this.show.new_password;
    },
    showConfirmPassword() {
      this.show.confirm_password = !this.show.confirm_password;
    },
    resetPassword() {
      const data = new FormData();
      data.append("new_password", this.new_password);
      data.append("reset_token", this.reset_token);
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        apiClient
          .post("auth/resetpassword/", data)
          .then((response) => {
            this.submitStatus = "OK";
            this.errorMessage = "";
            this.$swal(
              "Success!",
              response.data.message,
              "success"
            ).then(() => {
              this.$router.push({ name: "Login" });
            });
          })
          .catch((error) => {
            this.successMessage = "";
            this.submitStatus = "ERROR";
            this.errorMessage = error.response.data.message;
          });
      }
    },
  },
};
</script>

<style scoped>
.reset-password-container {
  width: 325px !important;
}
.login-card-body {
  padding: 1.5rem 2rem;
}
.login-page {
  background-image: url("~@/assets/svg/wave.svg");
  background-size: cover;
  background-position: center;
}
@media (max-width: 325px) {
  .card,
  .reset-password-container {
    width: 100% !important;
    border-radius: 0 !important;
  }
  .reset-password-container {
    padding: 1rem 0rem !important;
  }
}
</style>